import React from "react";
import CodeEditorMock from "./CodeEditorMock";

const ExperiencePanel = () => {
  return (
    <div className="experiencepanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          experience
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">
        <CodeEditorMock>
          I'm a <span class="string-color-text op-1">Full-Stack Developer</span>{" "}
          who enjoys building modern web apps from the ground up. I work a lot
          with <span class="react-color-text op-1">React</span>,{" "}
          <span class="nodejs-color-text op-1">Node.js</span>, and{" "}
          <span class="mongo-color-text op-1">MongoDB</span>, and I care about
          writing code that’s clean, efficient, and built to last.
          <br />
          <br />
          I’ve led agile teams, planned architectures, deployed projects, and
          handled everything in between. I’m comfortable taking ownership—from
          the first line of code to production. I know my way around{" "}
          <span class="js-color-text op-1">JavaScript</span>, REST APIs, and
          cloud-based setups.
          <br />
          <br />
          I’ve worked both in companies like{" "}
          <span class="string-color-text op-1">EF</span> and taken the lead at{" "}
          <span class="string-color-text op-1">Getting the Market</span>. My
          background also includes IT operations and close work with clients and
          cross-functional teams.
          <br />
          <br />
          I’m always exploring new tools and approaches to make better software.
          Clean code, speed, and good user experience are things I care deeply
          about.
        </CodeEditorMock>
      </div>
    </div>
  );
};

export default ExperiencePanel;
